/* eslint-disable no-console */
import { loadScript } from '@/helpers/scripts';
import { ref } from 'vue';

const API_KEY = process.env.VITE_YANDEX_MAPS_API_KEY;
const SCRIPT_URL = `https://api-maps.yandex.ru/v3/?apikey=${API_KEY}&lang=ru_RU`;

const ymaps3Lib = ref<typeof ymaps3 | null>(null);
const isReady = ref(false);
const isLibError = ref(false);

let scriptPromise: Promise<void> | null = null;
export function useYMaps() {
  async function getScriptLoadPromise() {
    if (scriptPromise) {
      return scriptPromise;
    }

    try {
      scriptPromise = loadScript(SCRIPT_URL);
      await scriptPromise;
    } catch (error) {
      isLibError.value = true;
      console.warn('ymaps3 not found');
      return null;
    }

    await scriptPromise;

    if (!('ymaps3' in window)) {
      isLibError.value = true;
      console.warn('ymaps3 not found');
      return null;
    }

    return scriptPromise;
  }

  async function init() {
    await getScriptLoadPromise();

    if (isLibError.value) {
      console.warn('ymaps3 not found');
      isReady.value = true;
      return null;
    }

    await ymaps3.ready;

    isReady.value = true;
    ymaps3Lib.value = ymaps3;

    return scriptPromise;
  }

  async function waitForYMaps() {
    await getScriptLoadPromise();

    if (isLibError.value) {
      console.warn('ymaps3 not found');
      return;
    }

    await ymaps3.ready;
  }

  return { ymaps3Lib, init, isReady, waitForYMaps, isLibError };
}

useYMaps().init();
